'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  const navigationAlt = {
    navigationAltShowClass: 'navigation-alt-show',
    navigationAltInClass: 'navigation-alt-in',
    transitionSpeed: 400,
    html: $('html'),
    init: function () {
      const self = this;
      $('button[data-toggle-primary-mobile-nav]').on('click', function (event) {
        if (self.html.hasClass(self.navigationAltInClass)) {
          self.closeMenu();
        } else {
          self.openMenu();
        }
        event.preventDefault();
      });
    },
    openMenu: function () {
      const self = this;
      self.html.addClass(self.navigationAltShowClass);
      self.openTimeout = setTimeout(function () {
        self.html.addClass(self.navigationAltInClass);
        clearTimeout(self.openTimeout);
      }, 30);
    },
    closeMenu: function () {
      const self = this;
      self.html.removeClass(self.navigationAltInClass);
      self.closeTimeout = setTimeout(function () {
        self.html.removeClass(self.navigationAltShowClass);
        clearTimeout(self.closeTimeout);
      }, self.transitionSpeed + 10);
    },
  };
  $(function () {
    navigationAlt.init();
  });
})(jQuery);
